import { render, staticRenderFns } from "./SpecialOpenPeriods.vue?vue&type=template&id=04d5a33e&"
import script from "./SpecialOpenPeriods.vue?vue&type=script&lang=ts&"
export * from "./SpecialOpenPeriods.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports